<template>
	<!-- 修改支付密码页面 -->
	<div class="setpaypwd_wrap">
		<!-- 顶部导航栏 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('setpaypwd.modifyPaymentPassword') }}</div>
		</div>

		<!-- 修改方式卡片 -->
		<div class="method_card">
			<div class="method_title">{{ $t('setpaypwd.setNewPaymentPassword') }}</div>
			<div class="method_switch" v-if="!codeStatus" @click="cutType(1)">
				{{ $t('setpwd.usemobilenumber') }}
			</div>
		</div>

		<!-- 验证码方式 -->
		<!-- <div class="form_card" v-if="codeStatus">
			<div class="bind_phone">{{ $t('setpwd.boundmobilenumber') }}{{ ycmobile }}</div>
			<div class="code_box">
				<div class="code_input">
					<input type="number" v-model="code" :placeholder="$t('setpwd.SMSverificationcode')">
				</div>
				<van-count-down :time="time" class="send_btn" @finish="timeCall">
					<template v-slot="timeData">
						<span @click="sendcode">{{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('setpwd.sendcode') }}</span>
					</template>
				</van-count-down>
			</div>
		</div> -->

		<!-- 登录密码方式 -->
		<div class="form_card" v-if="!codeStatus">
			<div class="form_item">
				<input :type="passwordInp" v-model="password" :placeholder="$t('setpaypwd.loginpassword')">
				<div class="eye_icon" @click="showPwd" :class="{ active: passwordInp === 'text' }">
					<van-icon :name="passwordInp === 'text' ? 'eye' : 'closed-eye'" />
				</div>
			</div>
		</div>

		<!-- 新支付密码输入 -->
		<div class="form_card">
			<div class="form_item">
				<div class="password_display" @click="showWord(1)">
					<input :type="newpasswordInp" :disabled="true" v-model="npassword" :placeholder="$t('setpaypwd.newpassword')">
				</div>
				<div class="eye_icon" @click="showNewsPwd" :class="{ active: newpasswordInp === 'text' }">
					<van-icon :name="newpasswordInp === 'text' ? 'eye' : 'closed-eye'" />
				</div>
			</div>
			<div class="form_item">
				<div class="password_display" @click="showWord(2)">
					<input :type="newpasswordInp" :disabled="true" v-model="rpassword" :placeholder="$t('setpwd.confirmnewpassword')">
				</div>
				<div class="eye_icon" @click="showNewsPwd" :class="{ active: newpasswordInp === 'text' }">
					<van-icon :name="newpasswordInp === 'text' ? 'eye' : 'closed-eye'" />
				</div>
			</div>
		</div>

		<!-- 提交按钮 -->
		<div  class="submit_btn" :class="{ disabled:  !npassword || !rpassword }"
			@click="dxRevise">
			{{ $t('setpwd.modify') }}
		</div>
		<!-- <div v-if="!codeStatus" class="submit_btn" :class="{ disabled: !password || !npassword || !rpassword }"
			@click="oldRevise">
			{{ $t('setpwd.modify') }}
		</div> -->

		<!-- 数字键盘弹窗 -->
		<van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
			<div class="keyboard_container">
				<van-password-input :value="psd_val" :mask="true" :focused="showKeyboard" @focus="showKeyboard = true" />
				<div class="keyboard_grid">
					<div class="keyboard_row" v-for="(row, rowIndex) in keyboardRows" :key="rowIndex">
						<div class="keyboard_key" v-for="(key, keyIndex) in row" :key="keyIndex"
							:class="{ 'no_bg': key === '', 'delete_key': key === 'x' }" @click="key === 'x' ? onDelete() : key !== '' ? onInput(key) : null">
							<span v-if="key === 'x'">x</span>
							<span v-else>{{ key }}</span>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
/**
 * 修改支付密码页面组件
 * 支持验证码修改和登录密码修改两种方式
 * 使用数字键盘输入6位支付密码
 */
import Vue from 'vue';
import { CountDown, Icon, Popup, PasswordInput } from 'vant';
import Fetch from '../../utils/fetch';

Vue.use(CountDown).use(Icon).use(Popup).use(PasswordInput);

export default {
	name: "setpaypwd",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {boolean} showKeyboard - 数字键盘是否显示
	 * @returns {boolean} write_psd - 密码输入弹窗是否显示
	 * @returns {number} time - 验证码倒计时
	 * @returns {string} password - 登录密码
	 * @returns {string} npassword - 新支付密码
	 * @returns {string} rpassword - 确认支付密码
	 * @returns {string} mobile - 手机号
	 * @returns {string} ycmobile - 脱敏手机号
	 * @returns {string} passwordInp - 登录密码输入框类型
	 * @returns {string} newpasswordInp - 新密码输入框类型
	 * @returns {boolean} codeStatus - 是否使用验证码方式
	 * @returns {string} psd_val - 数字键盘输入的值
	 * @returns {string} code - 验证码
	 * @returns {boolean} is_send - 是否已发送验证码
	 * @returns {number} nowInput - 当前输入的新密码编号 (1-新密码, 2-确认密码)
	 * @returns {Array} keyboardRows - 数字键盘按键布局
	 */
	data() {
		return {
			showKeyboard: true,
			write_psd: false,
			time: 0,
			password: '',
			rpassword: '',
			npassword: '',
			mobile: '',
			ycmobile: '',
			passwordInp: 'password',
			newpasswordInp: 'password',
			codeStatus: true,
			psd_val: '',
			code: '',
			is_send: false,
			nowInput: 1,
			keyboardRows: [
				[1, 2, 3],
				[4, 5, 6],
				[7, 8, 9],
				['', 0, 'x']
			]
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.loadUserInfo();
	},
	methods: {
		/**
		 * 加载用户信息
		 * 获取绑定手机号
		 */
		loadUserInfo() {
			Fetch('/user/info').then(r => {
				this.mobile = r.data.mobile;
				this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
			});
		},
		/**
		 * 显示数字键盘输入密码
		 * @param {number} n - 输入编号 (1-新密码, 2-确认密码)
		 */
		showWord(n) {
			this.nowInput = n;
			this.psd_val = '';
			this.write_psd = true;
		},
		/**
		 * 数字键盘输入处理
		 * @param {number|string} key - 输入的数字
		 */
		onInput(key) {
			this.psd_val = (this.psd_val + key).slice(0, 6);
			if (this.psd_val.length === 6) {
				if (this.nowInput === 1) {
					this.npassword = this.psd_val;
				} else {
					this.rpassword = this.psd_val;
				}
				this.write_psd = false;
			}
		},
		/**
		 * 删除输入的数字
		 */
		onDelete() {
			this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
		},
		/**
		 * 切换修改方式
		 * @param {number} n - 方式编号 (1-验证码)
		 */
		cutType(n) {
			this.codeStatus = n === 1;
			this.rpassword = '';
			this.npassword = '';
		},
		/**
		 * 倒计时结束回调
		 */
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		/**
		 * 发送验证码
		 */
		sendcode() {
			if (this.is_send) return;
			this.is_send = true;

			Fetch("/index/forgetpwd_email_code", {
				mobile: this.mobile
			}).then(() => {
				this.time = 60 * 1000;
				this.$toast({
					className: "toastName",
					message: this.$t('setpwd.sendsuccessfully'),
				});
			}).catch(() => {
				this.is_send = false;
			});
		},
		/**
		 * 显示/隐藏登录密码
		 */
		showPwd() {
			this.passwordInp = this.passwordInp === 'password' ? 'text' : 'password';
		},
		/**
		 * 显示/隐藏新密码
		 */
		showNewsPwd() {
			this.newpasswordInp = this.newpasswordInp === 'password' ? 'text' : 'password';
		},
		/**
		 * 验证码方式修改支付密码
		 */
		dxRevise() {
			if (!this.npassword) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.newpasswordcannotbeempty') });
				return;
			}
			if (this.npassword !== this.rpassword) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.inconsistent') });
				return;
			}

			Fetch('/user/resetpaypwd_code', {
				code: this.code,
				npassword: this.npassword,
			}).then(() => {
				this.$toast({ className: "toastName", message: this.$t('setpwd.modifiedsuccessfully') });
				sessionStorage.setItem('pwd', this.npassword);
				if (this.$route.query.redirect) {
					this.$router.replace(this.$route.query.redirect + '?change');
				} else {
					this.$router.replace('/safe');
				}
			});
		},
		/**
		 * 登录密码方式修改支付密码
		 */
		oldRevise() {
			if (!this.password) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.loginpasswordcannotbeempty') });
				return;
			}
			if (!this.npassword) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.newpasswordcannotbeempty') });
				return;
			}
			if (this.npassword !== this.rpassword) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.inconsistent') });
				return;
			}
			var reg = new RegExp("^[0-9]*$");
			if (!reg.test(this.npassword)) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.pureNumber') });
				return;
			}
			if (!reg.test(this.rpassword)) {
				this.$toast({ className: "toastName", message: this.$t('setpaypwd.pureNumber') });
				return;
			}

			Fetch('/user/resetpaypwd', {
				passwd: this.password,
				npasswd: this.npassword,
			}).then(() => {
				this.$toast({ className: "toastName", message: this.$t('setpwd.modifiedsuccessfully') });
				this.$router.replace('/safe');
			});
		}
	}
};
</script>

<style lang="less" scoped>
/**
 * 修改支付密码页面样式
 * 采用卡片式设计，与登录密码页面保持一致的视觉风格
 */
.setpaypwd_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 30px;
}

/* 顶部背景 */
.red_top_bg {
	height: 50px;
	// background-image: url(../images/user/moneybag/bg.png);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

// .back_left {
// 	background: url(../images/item/back_w.png) no-repeat center center;
// }

.big_tit {
	color: #fff;
}

/* 修改方式卡片 */
.method_card {
	position: relative;
	margin-top: 74px;
	margin-left: 15px;
	margin-right: 15px;
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	z-index: 11;

	.method_title {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		margin-bottom: 10px;
	}

	.method_switch {
		font-size: 13px;
		color: #ff5252;
		cursor: pointer;
	}
}

/* 表单卡片 */
.form_card {
	margin: 15px;
	background: #fff;
	border-radius: 12px;
	padding: 5px 0;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.bind_phone {
		padding: 16px 20px;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #f5f5f5;
	}

	.form_item {
		display: flex;
		align-items: center;
		padding: 16px 20px;
		border-bottom: 1px solid #f5f5f5;

		&:last-child {
			border-bottom: none;
		}

		input {
			flex: 1;
			border: none;
			outline: none;
			font-size: 15px;
			color: #333;
			background: transparent;

			&::placeholder {
				color: #ccc;
			}

			&:disabled {
				color: #333;
				-webkit-text-fill-color: #333;
				opacity: 1;
			}
		}

		.password_display {
			flex: 1;
			cursor: pointer;
		}

		.eye_icon {
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			.van-icon {
				font-size: 20px;
				color: #ccc;

				&.active {
					color: #ff5252;
				}
			}
		}
	}
}

/* 验证码输入框 */
.code_box {
	display: flex;
	align-items: center;
	padding: 12px 20px;

	.code_input {
		flex: 1;
		padding: 12px 15px;
		background: #f5f5f5;
		border-radius: 8px;
		margin-right: 10px;

		input {
			width: 100%;
			border: none;
			outline: none;
			font-size: 15px;
			color: #333;
			background: transparent;

			&::placeholder {
				color: #ccc;
			}
		}
	}

	.send_btn {
		padding: 12px 20px;
		background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
		color: #fff;
		font-size: 14px;
		border-radius: 8px;
		white-space: nowrap;
		cursor: pointer;
	}
}

/* 提交按钮 */
.submit_btn {
	margin: 30px 15px;
	height: 48px;
	line-height: 48px;
	text-align: center;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	border-radius: 24px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
	}

	&.disabled {
		opacity: 0.5;
		pointer-events: none;
	}
}

/* 数字键盘容器 */
.keyboard_container {
	padding: 0 0 20px;
}

/* 数字键盘网格 */
.keyboard_grid {
	padding: 10px 15px 0;
	background: #f0f0f0;
}

.keyboard_row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;

	&:last-child {
		margin-bottom: 0;
	}
}

.keyboard_key {
	width: 32%;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	border-radius: 5px;
	font-size: 20px;
	font-weight: 600;
	color: #333;
	cursor: pointer;
	transition: background 0.15s;

	&:active {
		background: #e0e0e0;
	}

	&.no_bg {
		background: transparent;
		cursor: default;

		&:active {
			background: transparent;
		}
	}

	&.delete_key {
		color: #757880;
		font-size: 18px;
	}
}

/deep/ .van-password-input {
	margin: 30px 15px 0;
}

/deep/ .van-popup--bottom.van-popup--round {
	border-radius: 16px 16px 0 0;
}
</style>
